import { defineMessages } from 'react-intl';

export default defineMessages({
    policyTypeColoumn: {
      id: "policycommon.component.umbrella-underlying-policy.Type",
      defaultMessage: "Type",
    },
    policyNumberColoumn: {
      id: "policycommon.component.umbrella-underlying-policy.Policy Number",
      defaultMessage: "Policy Number",
    },
    liabilityLimitColumn: {
      id: "policycommon.component.umbrella-underlying-policy.LiabilityLimit",
      defaultMessage: "Liability Limit",
    },
    expirationdateColumn: {
      id: "policycommon.component.umbrella-underlying-policy.Expiration date",
      defaultMessage: "Expiration date",
    },
    effectiveDateColumn: {
      id: "policycommon.component.umbrella-underlying-policy.Effective date",
      defaultMessage: "Effective date",
    },
    underlyingPolicies: {
      id: "policycommon.component.umbrella-underlying-policy.Underlying Policy Details",
      defaultMessage: "Underlying Policy Details",
    }
});
